import { Component, Directive, HostBinding, HostListener, Inject, Input, OnInit, Optional } from '@angular/core';
import { ControlContainer, UntypedFormArray, UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApplicantService } from 'app/laas/applicant.service';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment as ENV } from '../../../../../environments/environment';
import { CommonFieldsService } from 'app/laas/common-fields.service';
import { Router } from '@angular/router';
import { OpenDialog } from 'app/laas/dialog-for-cbs/dialog.component';
import { RenewalInboxService } from 'app/admin/renewal-inbox/renewal-inbox.service';
import { OpenDialogYesOrNo } from 'app/laas/dialog-yes-or-no/dialog-yes-or-no.component';
import { CibilReportService } from 'app/laas/financial/cibil-report/cibil-report.service';
import * as constants from '../../../../constant'


@Component({
  selector: "wl-loan-renewal-form",
  templateUrl: "./loan-renewal-form.component.html",
  styles: [],
  providers: [ApplicantService, RenewalInboxService],
})
export class LoanRenewalFormComponent implements OnInit {
  loanRenewalForm: UntypedFormGroup;
  cropDataForm: UntypedFormGroup;
  detail: any;
  isDataPending = false;
  crops: Observable<any>;
  crops1: String = '';
  acre1: number = 0;
  acre2: number = 0;
  acre3: number = 0;
  acresum: number = 0;
  consentformdata: any;
  kcc_form_disable: boolean = false;
  yeskcc: boolean = false;
  cropping_pattern: any;
  kcc_form_flag: boolean = false;
  yeskccrdbtn1: any;
  cropdetails: Observable<any>;
  earningsdata: Observable<any>;
  farmScoredata: Observable<any>;
  add_sof: any;
  gross_assessed_limit: any;
  proposed_sof_ro: any;
  mapurl: any;
  sof_ofkrs: any;
  datanotverified: boolean = false;
  datamessage: any;
  proposed_amount: any;
  proposed_dp_k: any;
  isReportPending: boolean;
  reportLink: string;
  token: any;
  crif_score_coappflag: boolean = false;
  reportdate: string;
  bhoomiflag: boolean;
  bhoomi: string;
  bhoomi_land: string;
  bhoomi_landflag: boolean;
  satsureflag: boolean;
  satsure_report: string;
  mutationreport: string;
  mutationflag: boolean;
  checkerflag: boolean = false;
  bhoomi_files: Observable<any>;
  maker_checker_flag: boolean = true;
  maker_checker_submitflag: boolean = false;
  checker_flag: boolean = false;
  annexure_form_status: Observable<any>;
  dateofmaker: any;
  dateofchecker: any;
  nameofthechecker: any;
  empIdofchecker: any;
  comments: any;
  approval_status: any;
  comments_flag: boolean = false;
  role: string;
  roleId: number;
  cropping_pattern_data: any;
  multisatsuredatas: any = [];
  landValuesArray: any = [];
  cropping_pattern_data1: any;
  crop_data_form_valid: boolean = false;
  cropDataFormValid: boolean;
  final_assed_limit: any;
  landValueArrayLength = 0;
  landValueValidFlag: boolean = true;
  resp_cropping_details: any;
  isSubmitDisabled: boolean;
  disableEverything: boolean;
  accNoUnmasked: any;
  custId: any;
  acreOrHectare: string;
  showGuntas: boolean;
  breFailure: boolean;
  score: any;
  isMP: boolean;
  nameOfMaker: string;
  staffId: string;
  today: any;
  isAP: boolean;
  isAddcustomClass: boolean;
  pointerStyle: object;
  hideButton: boolean;
  overAllStatusMessageToDisplay: string;
  showOverallCard: boolean;
  loanAmountInNumbers: any;
  loanAmountInDecimals: any;

  constructor(
    private applicant: ApplicantService,
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private common: CommonFieldsService,
    private router: Router,
    private renew: RenewalInboxService,
    private crifReport: CibilReportService,
    private cibil: CibilReportService,
  ) {
    this.loanRenewalForm = this.fb.group({
      name_of_borrower: [""],
      name_of_co_applicant: [""],
      customer_id: [""],
      bank_acc_no: [""],
      corps_address: [""],
      mobile_number: [""],
      aadhaar_number: [""],
      dob_borrower: [""],
      credit_facility_since: [""],
      purpose_of_adv: [""],
      type_of_farmer: [""],
      assest_classification: [""],
      category_if_applicable: [""],
      date_of_sanction: [""],
      last_renewal_date: [""],
      due_date_of_review: [""],
      type_of_facility: [""],
      existing_loan_in_lakhs: [""],
      acresum: [""],
      outstanding_as_on: [""],
      comments: [""],
      approval_status: [""],

      land_area: [""],
      land_ownership: [""],
      cropping_pattern: [""],
      satellite_image: [""],
      latitude: [""],
      longitude: [""],
      irrigation_status: [""],
      // crop_det_lastthree_years: [''],
      crop_int_lastthree_years: [""],
      haz_hist_lastthree_years: [""],
      land_value: ["",],
      soil_health: [""],
      water_level: [""],
      mandi_distance: [""],
      // earning_from_lastthree_years: [''],
      summer_acres: [""],
      summer: [""],
      loan_amt_kharif: [""],
      scale_kharif: [""],
      scale_rabi: [""],
      loan_amt_rabi: [""],
      scale_summer: [""],
      loan_amt_summer: [""],
      crop_insurance_amount: [""],
      total_limit: [""],
      ten_per_limit_post_harvest: [""],
      twenty_per_limit_maint_expenses: [""],
      gross_assessed_limit: [""],
      add_sof: [
        "",
      ],
      sanction_limit: [""],
      existing_drawing_power: [""],
      proposed_dp_k: [""],
      sanction_limit_j: [""],
      existing_dp_apf: [""],
      roi_apf: [""],
      sec_hypo_of_crops: [""],
      kcc_union_green_card_ubi: [""],
      total_five_c: [""],
      nameofthemaker: ["", Validators.required],
      empIdofmaker: ["", Validators.required],
      dateofmaker: ["", Validators.required],
      final_assed_limit: ["", Validators.required],
      nameofthechecker: [""],
      empIdofchecker: [""],
      dateofchecker: [""],
      proposed_sof_ro: ["", Validators.required],
      sof_ofkrs: [""],
      crif_score_data: ["", Validators.required],
      name_of_borrower2: ["", Validators.required],

      kharif: [""],
      kharif_acres: [""],
      rabi: [""],
      rabi_acres: [""],
      checkbox: [""],
      kharif1: [],
      crif_score_coapp: [""],
      name_of_coapp: [""],
      land_score: [""],
      cbs_status: [""]
    });

    this.cropDataForm = this.fb.group({
      cropArray: this.fb.array([]),
    });

    if (this.applicant.shouldIbeClicked()) {
      this.pointerStyle = { 'pointer-events': 'auto' }
    } else {
      this.pointerStyle = { 'pointer-events': 'none' }
    }

  }

  cropArray(): UntypedFormArray {
    return this.cropDataForm.get("cropArray") as UntypedFormArray
  }

  newCropArray(): UntypedFormGroup {
    return this.fb.group({
      crop_season: '',
      crop_name: '',
      area: '',
      scal_of_fin: '',
      loan_amount: '',
      add_sof_percent: ["", [Validators.max(100), Validators.min(0)]],
      add_sof_amt: ''
    })
  }
  // Crop Proposed	Area of cultivation (In Acres)	Scale of Finance (per Acres)	Loan Amount(Rs)

  addCrop() {
    this.cropArray().push(this.newCropArray());
  }

  async ngOnInit() {

    await this.applicant.getLoanAmountStrings().subscribe((resp)=>{
      sessionStorage.setItem('loanAmounts',JSON.stringify(resp))
      this.loanAmountInNumbers = JSON.parse(sessionStorage.getItem('loanAmounts')).LOAN_LIMIT;
      this.loanAmountInDecimals = JSON.parse(sessionStorage.getItem('loanAmounts')).LOAN_LIMIT_DECIMAL;
    },(err)=>{
      this.router.navigate(['/no_page'])
    })

    this.today = new Date().getTime()
    // this.cibil.getCibilData().subscribe(resp => {
    //   console.log(resp)
    //   // if (resp && resp.result && resp.result.score) {
    //   //   this.score = resp.result.score
    //   // } else {
    //   //   this.score = "Report Not Generated"
    //   // }

    // }) //commented as it is already called in LR and consent form



    this.setStateAndFlags();
    this.setRoleIdnMakerCheckFlag();
    // let continueAfterBre = await this.getTotalBreStatus();
    // if (continueAfterBre) {
      // let continueAfterCbs = await this.getCbsStatus();
      // if (continueAfterCbs) {
        // let continueAfterGetOverallStatus = await this.getOverallStatus();
        // if (continueAfterGetOverallStatus) {
          this.callGetEverythingAndSetFlags();
          this.getApplicantLoanFinalData();
        // } else {
        //   // show banner with status message
        // }
      // } else {
      //   //cbs api failure
      //   this.snackbar.open('Failed at CBS status check.', 'OK', { duration: 5000 })
      // }
    // } else {
    //   //show bre error and bre error banner
    //   this.snackbar.open('Failed at BRE', 'OK', { duration: 5000 })
    // }

    this.isSubmitDisabled = true
    this.cropDataForm.statusChanges.subscribe((status) => {
      if (this.cropDataForm.dirty) {
        console.warn('template form dirty - yes: ', status);
        this.isSubmitDisabled = false
      } else {
        console.warn('template form dirty - no: ', status);
        this.isSubmitDisabled = true
      }
    });
    this.annexure_form_status = this.common.getApprovalStatus();

    this.checkFormValid();
  }

  ngAfterViewChecked() {
    // console.log("ngAfterViewChecked")
    let formdata1 = this.loanRenewalForm.getRawValue();
    // this.proposed_dp_k = Math.round(
    //   this.getfinalsanctionamount(

    //     formdata1.sanction_limit,
    //     this.final_assed_limit
    //   )
    // );

    // this.final_assed_limit = this.proposed_sof_ro + this.gross_assessed_limit;

    this.nameOfMaker = sessionStorage.getItem('userName')
    this.staffId = sessionStorage.getItem('staffId')
    this.loanRenewalForm.patchValue({ dateofmaker: this.currentdatetoday("dd/mm/yyyy") })

  }

  getApplicantID() {
    return sessionStorage.getItem("wl-applicant-id");
  }

  getLandValue(value) {
    // console.log(value, "value in parent");
    let a = this.landValuesArray;
    let b = value;

    let c = a.filter(value => value.index == b.index).map(value => {
      // console.log(value,'value')
      if (value) {
        if (b.value.trim()) {
          return value.value = b.value;
        } else {
          let indexofnewlandvalue = a.findIndex(i => i.index === value.index);
          a.splice(indexofnewlandvalue, 1)
        }
      }
    }
    );
    if (!c.length && b.value.trim()) {
      a.push(b);
    }
    // }
    // console.log(a, 'second value');
    this.landValuesArray = a;
    console.log(this.landValuesArray);


    if (this.landValueArrayLength == this.landValuesArray.length) {
      this.landValueValidFlag = false;
    } else {
      this.landValueValidFlag = true;
    }
  }

  loanRenewalformSubmit() {
    let formdata = this.loanRenewalForm.getRawValue();
    let formdata1 = this.cropDataForm.getRawValue();
    console.log(formdata);
    let dataobj = {
      annexure_data: {
        land_value: this.landValuesArray,
        nameofthemaker: formdata.nameofthemaker,
        empIdofmaker: formdata.empIdofmaker,
        dateofmaker: formdata.dateofmaker,

        proposed_sof_ro: formdata.proposed_sof_ro,
        final_assed_limit: formdata.final_assed_limit,

        proposed_dp_k: formdata.proposed_dp_k,
        sof_ofkrs: formdata.sof_ofkrs,
        croparraydata: formdata1.cropArray,
      },
      approval_status: "approved",
      userId: sessionStorage.getItem("wl-admin-id"),
    };

  }

  getValidity(i) {
    if ((<UntypedFormArray>this.cropDataForm.get('cropArray')).controls[i].invalid) {
      // console.log('trueeeeeeee',i);
      // this.crop_data_form_valid=true;
    } else { //console.log('falseeeeeeeeeeee',i);
      // this.crop_data_form_valid=false; 
    }
    return (<UntypedFormArray>this.cropDataForm.get('cropArray')).controls[i].invalid;
  }

  checkFormValid() {
    console.log(this.cropDataForm.valid, "crop data valid or not");
    if (this.cropDataForm.valid) {
      this.cropDataFormValid = true;
    } else {
      this.cropDataFormValid = false;
    }
  }

  calcsof(i) {
    console.log('calcsof called', i, 'i value')
    let formdata = this.cropDataForm.getRawValue();
    let formdata1 = this.loanRenewalForm.getRawValue();

    if (formdata.cropArray[i] && formdata.cropArray[i].add_sof_percent) {
      let add_sof_amt = Math.round((formdata.cropArray[i].add_sof_percent * formdata.cropArray[i].loan_amount) / 100); //%
      console.log(add_sof_amt);
      let loanAmount = formdata.cropArray[i].loan_amount
      let add_sof_new = add_sof_amt + loanAmount;
      (<UntypedFormArray>this.cropDataForm.controls['cropArray']).at(i).get("add_sof_amt").setValue(add_sof_new); //amount

    }

    if (formdata.cropArray[i] && formdata.cropArray[i].add_sof_amt) {
      console.log(formdata.cropArray[i].add_sof_amt)
      console.log((<UntypedFormArray>this.cropDataForm.controls['cropArray']).at(i).get("add_sof_amt").value)
      let add_sof_amt_total = 0;
      for (let i = 0; i < formdata.cropArray.length; i++) {
        add_sof_amt_total = add_sof_amt_total + (<UntypedFormArray>this.cropDataForm.controls['cropArray']).at(i).get("add_sof_amt").value;
      }
      console.log(add_sof_amt_total)
      this.proposed_sof_ro = add_sof_amt_total;
      this.final_assed_limit = this.proposed_sof_ro + this.gross_assessed_limit;

      console.log("this.final_assed_limit ,this.proposed_sof_ro ,this.gross_assessed_limit", this.final_assed_limit, this.proposed_sof_ro, this.gross_assessed_limit)
      this.proposed_dp_k = Math.round(
        this.getfinalsanctionamount(

          formdata1.sanction_limit,
          this.final_assed_limit
        )
      );
    }
  }

  getfinalsanctionamount(sanction_limit, total_amount) {
    return Math.min(sanction_limit, total_amount, this.loanAmountInNumbers);
  }

  consentcheckerSubmit() {
    let dateofchecker = this.dateofchecker;
    let nameofthechecker = this.nameofthechecker;
    let empIdofchecker = this.empIdofchecker;
    let comments = this.comments;
    let approval_status = this.approval_status;
    let dataobj = {
      annexure_data: {
        dateofchecker,
        nameofthechecker,
        empIdofchecker,
        comments,
      },
      approval_status,
      userId: sessionStorage.getItem("wl-admin-id"),
    };
    // this.applicant.consentformannexureSubmit(dataobj).subscribe((resp) => {
    //   console.log("resp " + JSON.stringify(resp));
    //   if (resp) {
    //     this.snackbar.open(resp.message, "OK", { duration: 3000 });
    //     this.ngOnInit();
    //   }
    // });
  }

  approval_stfn(value) {
    if (value == "pending" || value == "rejected") {
      this.comments_flag = true;
    } else {
      this.comments_flag = false;
    }
  }

  currentdatetoday(format) {
    let today = new Date();
    let dd = today.getDate();
    let dd1 = "";
    let mm1 = "";
    let today1 = "";

    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd1 = "0" + dd;
    } else {
      dd1 = "" + dd;
    }

    if (mm < 10) {
      mm1 = "0" + mm;
    } else {
      mm1 = "" + mm;
    }

    if (format == "dd-mm-yyyy") {
      return (today1 = dd1 + "-" + mm1 + "-" + yyyy);
    } else if (format == "mm-dd-yyyy") {
      return (today1 = mm1 + "-" + dd1 + "-" + yyyy);
    } else if (format == "mm/dd/yyyy") {
      return (today1 = mm1 + "/" + dd1 + "/" + yyyy);
    } else if (format == "dd/mm/yyyy") {
      return (today1 = dd1 + "/" + mm1 + "/" + yyyy);
    }
  }

  generateReport() {
    this.isReportPending = true;
    this.applicant.getReport().subscribe((report) => {
      this.isReportPending = false;
      console.log(report)
      // this.reportLink = `${ENV.nodeUrl.slice(0, -2)}${report}`;
      this.reportLink = 'data:application/pdf;base64,' + report;
      this.token = report.key;

    });

    let formdata = this.loanRenewalForm.getRawValue()

    // if (formdata.existing_drawing_power <= formdata.final_assed_limit) {
    //   this.sendToCbs()
    // } else if (formdata.existing_drawing_power > formdata.final_assed_limit) {
    //   this.reject()
    // }
  }

  downloadPdf() {
    const downloadLink = document.createElement("a");
    let pdfGeneratedDate = new Date().getTime();
    const fileName = "Loan-renewal-application_" + pdfGeneratedDate + ".pdf";

    downloadLink.href = this.reportLink;
    downloadLink.download = fileName;

    downloadLink.click();
  }

  sendToCbs() {
    let id = this.custId;
    let name = this.loanRenewalForm.getRawValue().name_of_borrower;
    let accNo = this.accNoUnmasked;
    let formdata = this.loanRenewalForm.getRawValue()
    if (id && name && accNo) {
      if (formdata.existing_drawing_power < formdata.final_assed_limit) {
        this.renew.sendToCbs(id, name, accNo).subscribe(resp => {
          console.log(resp)
          if (resp && resp.respMessage && resp.respMessage.message && resp.respMessage.message == "success") {
            // this.snackbar.open('Sent to CBS successfully', 'OK',{duration:3000})

            this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/laas/applications/loan-renewal-form']);
              const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
                width: 'auto', height: 'auto',
                data: { heading: "The case has been sent to CBS Successfully", content: constants.DOWNLOAD_DES, button1Text: "Yes", button2Text: "No" }
              });

              dialogRef.afterClosed().subscribe(res => {
                console.log(res)
                if (res == "close") {
                  window.close()
                } else {
                  this.ngOnInit()
                }
              })
            })
          }else{
            const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
              width: 'auto', height: 'auto',
              data: { heading: "Failed sent to CBS. Please try again later", content: "", button1Text: "OK" }
            });
            dialogRef.afterClosed().subscribe((resp)=>{
              this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
              })
            })
          }
          this.ngOnInit()
        },(err)=>{
          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: 'auto', height: 'auto',
            data: { heading: "Failed sent to CBS. Please try again later", content: "", button1Text: "OK" }
          });
          dialogRef.afterClosed().subscribe((resp)=>{
            this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
            })
          })
        })
      } else {
        console.log("Final assessed limit < E DP")
      }

    }
  }

  reject() {
    let id = this.getApplicantID();
    this.applicant.rejectLoan(id).subscribe(resp => {
      if (resp && resp.success) {
        console.log(resp)
        // this.snackbar.open("The Applicant is rejected","OK",{duration:3000})
        this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/laas/applications/loan-renewal-form']);
          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: 'auto', height: 'auto',
            data: { heading: "The case has been rejected Successfully.", content: "The case has been shifted to failure box. Do you want to stay on the page?", button1Text: "Yes", button2Text: "No" }
          });

          dialogRef.afterClosed().subscribe(res => {
            console.log(res)
            if (res == "close") {
              window.close()
            } else {
              this.ngOnInit()
            }
          })
        })
      }else{
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: { heading: "Failed update loan status. Please try again later", content: "", button1Text: "OK" }
        });
        dialogRef.afterClosed().subscribe((resp)=>{
          this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
          })
        })
      }

    },(err)=>{
      const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
        width: 'auto', height: 'auto',
        data: { heading: "Failed update loan status. Please try again later", content: "", button1Text: "OK" }
      });
      dialogRef.afterClosed().subscribe((resp)=>{
        this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
        })
      })
    })
  }

  setStateAndFlags() {
    let stateValue = sessionStorage.getItem('wEnlw3OeU3')
    if (stateValue == "xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1") {
      this.isMP = true
      this.acreOrHectare = "Hectare"
      this.showGuntas = false
    } else if (stateValue == "KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y") {
      this.acreOrHectare = "Acre"
      this.showGuntas = true
      this.isMP = false
    } else if (stateValue == "X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6") {
      this.acreOrHectare = "Acre"
      this.showGuntas = true
      this.isMP = false;
      this.isAP = true;
    }
  }

  getTotalBreStatus() {
    return new Promise(async (resolve, reject) => {
      this.crifReport.getBreStatus().subscribe(result => {
        console.log(result);
        // result = "Failure"
        if (result == "Failure") {
          this.breFailure = true;
          resolve(false);
        } else {
          this.breFailure = false;
          resolve(true);
        }
      })
    })
  }

  getCbsStatus() {
    return new Promise(async (resolve, reject) => {
      this.applicant.getCbsStatus().subscribe(resp => {
        console.log(resp, "resp from laas auth guard")
        if (resp && resp.success) {
          if ((resp && resp.result && resp.result[ENV.cbsStatusFormat]) || (resp && resp.result && resp.result.sent_to_cbs_date) || (resp && resp.result && resp.result.sent_to_cbs_id)) {
            this.disableEverything = true;
          }
        }
        resolve(true)
      })
    })
  }

  setRoleIdnMakerCheckFlag() {
    this.role = sessionStorage.getItem("wzbvdsjvbbs");
    if (this.role === "5b8f43f6-9ae5-4642-8939-310771661e4f") {
      this.roleId = 5;
      this.maker_checker_flag = false;
    } else if (this.role === "4dfb05e4-ca35-492b-8a6a-0e0775426090") {
      this.roleId = 4;
      this.checker_flag = true;
    }
    console.log('maker_checker_flag', this.maker_checker_flag, 'checker_flag', this.checker_flag);
  }

  callGetEverythingAndSetFlags() {
    this.applicant.getEverything().subscribe((details) => {
      if (details.docs) {
        const bhoomi = (details.docs && details.docs.assets && details.docs.assets.bhoomi) || {};
        // window.alert(JSON.stringify(bhoomi))
        if (bhoomi && bhoomi.file) {
          this.bhoomi = ENV.imageUrl + bhoomi.file;
          this.bhoomiflag = true;
        }

        const bhoomi_land = (details.docs && details.docs.assets && details.docs.assets.bhoomi_land) || {};
        if (bhoomi_land && bhoomi_land.file) {
          this.bhoomi_land = ENV.imageUrl + bhoomi_land.file;
          this.bhoomi_landflag = true;
        }

        const satsuredata = (details.docs && details.docs.assets) || {};

        if (
          satsuredata.satSure &&
          satsuredata.satSure.input &&
          satsuredata.satSure.input.length &&
          satsuredata.satSure.input
        ) {
          let lastArray = satsuredata.satSure.input.length - 1;

          if (
            satsuredata.satSure &&
            satsuredata.satSure.input &&
            satsuredata.satSure.input.length &&
            satsuredata.satSure.input[lastArray].wlOutput &&
            satsuredata.satSure.input[lastArray].wlOutput.reportUrl
          ) {
            this.satsure_report =
              ENV.imageUrl +
              satsuredata.satSure.input[lastArray].wlOutput.reportUrl;
            this.satsureflag = true;
          }
        }

        const mutationreport = (details.docs && details.docs.assets) || {}
        if (mutationreport.mr && mutationreport.mr.pdfFile) {
          this.mutationreport = ENV.docUrl + mutationreport.mr.htmlFile;
          this.mutationflag = true;
        }
      }
    },(err)=>{
      this.snackbar.open("Failed to fetch Information.Please try again.","OK",{duration:3000})
    });
  }

  getApplicantLoanFinalData() {
    let applicantId = this.getApplicantID();
    let payload = { applicantId };
    this.applicant
      .getApplicantLoanFinalData(payload)
      .subscribe((resp) => {

        console.log(
          "response from getApplicantLoanFinalData" + JSON.stringify(resp)
        );
        console.log(
          "response from getApplicantLoanFinalData", resp
        );

        this.loanRenewalForm.patchValue({ cbs_status: "Pending" })

        if (!resp.success) {
          this.datanotverified = true;
          this.datamessage = resp.message;
        }

        if (resp && resp.result && resp.result.coapplicant_data && resp.result.coapplicant_data && resp.result.coapplicant_data.name) {
          this.loanRenewalForm.patchValue({ name_of_co_applicant: resp.result.coapplicant_data.name })
        }


        if (resp.success) {
          this.proposed_amount = resp.result.proposed_amount;

          let current_date = new Date();
          let current_year = current_date.getFullYear();
          let years_list = [];
          for (let i = 0; i < 3; i++) {
            years_list.push(current_year - i);
          }

          if (resp && resp.result && resp.result.crifReport) {
            let resp_crifReport = resp.result.crifReport;
            this.score = resp_crifReport.credit_score ? resp_crifReport.credit_score : "Report Not Generated"
          }

          if (this.roleId == 5 && resp.result.consent_approval_status == 'pending' && resp.result.maker_approval_status == 'pending') {
            this.maker_checker_submitflag = false;
          } else if (this.roleId == 5) {
            this.maker_checker_submitflag = true;
          }

          if (this.roleId == 4 && resp.result.consent_approval_status == 'pending' && resp.result.maker_approval_status == 'approved') {
            this.maker_checker_submitflag = false;
          } else if (this.roleId == 4) {
            this.maker_checker_submitflag = true;
          }


          //bhoomi_land_input_data BHOOMI
          if (
            resp &&
            resp.result &&
            resp.result.bhoomi &&
            resp.result.bhoomi.land_input_data
          ) {
            let bhoomi_land_input_data = resp.result.bhoomi.land_input_data;
            this.loanRenewalForm.patchValue({
              land_area: bhoomi_land_input_data.land_area ? bhoomi_land_input_data.land_area : "",
            });
            this.loanRenewalForm.patchValue({
              land_ownership: bhoomi_land_input_data.land_ownership ? bhoomi_land_input_data.land_ownership : "",
            });
          }

          //RESD6 BHOOMI
          if (
            resp &&
            resp.result &&
            resp.result.bhoomi &&
            resp.result.bhoomi.files &&
            resp.result.bhoomi.files.length
          ) {
            this.bhoomi_files = resp.result.bhoomi.files;
            console.log('if our cond')
          } else {
            console.log('fall our cond')
            this.hideButton = true;
            let emptyArray: any = []
            this.bhoomi_files = emptyArray;
          }

          var currentDate = new Date().toJSON().slice(0, 10);
          this.reportdate = this.currentdatetoday("dd/mm/yyyy");

          //satsurelOutput
          if (
            resp &&
            resp.result &&
            resp.result.satSureData &&
            resp.result.satSureData.input &&
            resp.result.satSureData.input.length &&
            resp.result.satSureData.input[0] &&
            resp.result.satSureData.input[0].wlOutput
          ) {
            let satsurelOutput = resp.result.satSureData.input[0].wlOutput;
            let path = [];
            if (
              satsurelOutput &&
              satsurelOutput.farmStats &&
              satsurelOutput.farmStats.cropPerformance &&
              satsurelOutput.farmStats.cropPerformance.data
            ) {
              this.cropdetails = satsurelOutput.farmStats.cropPerformance.data;
            }
            if (
              satsurelOutput &&
              satsurelOutput.farmStats &&
              satsurelOutput.farmStats.revenuePotential &&
              satsurelOutput.farmStats.revenuePotential.data
            ) {
              this.earningsdata = satsurelOutput.farmStats.revenuePotential.data;
            }

            if (satsurelOutput && satsurelOutput.overallScore) {
              this.loanRenewalForm.patchValue({
                land_score: satsurelOutput.overallScore ? satsurelOutput.overallScore : 0,
              });
            }
            if (
              satsurelOutput &&
              satsurelOutput.farmStats &&
              satsurelOutput.farmStats.farmScore &&
              satsurelOutput.farmStats.farmScore.data
            ) {
              this.farmScoredata = satsurelOutput.farmStats.farmScore.data;
            }

            if (satsurelOutput && satsurelOutput.droughtYears) {
              console.warn(satsurelOutput.droughtYears, "Drought");
              let hazarddata = satsurelOutput.droughtYears.filter((value) =>
                years_list.includes(value)
              );
              this.loanRenewalForm.patchValue({
                haz_hist_lastthree_years: hazarddata.length
                  ? hazarddata
                  : "None",
              });
            }
            if (satsurelOutput && satsurelOutput.farmStats) {
              this.loanRenewalForm.patchValue({
                irrigation_status: satsurelOutput.farmStats.irrigationCondition
                  ? satsurelOutput.farmStats.irrigationCondition
                  : "",
              });
              this.loanRenewalForm.patchValue({
                soil_health: satsurelOutput.farmStats.soilType
                  ? satsurelOutput.farmStats.soilType
                  : "",
              });
            }

            if (satsurelOutput && satsurelOutput.groundWater) {
              this.loanRenewalForm.patchValue({
                water_level: `${satsurelOutput.groundWater.minGraph ? satsurelOutput.groundWater.minGraph : ""
                  }/${satsurelOutput.groundWater.maxGraph ? satsurelOutput.groundWater.maxGraph : ""
                  }`,
              });
            }

            if (satsurelOutput && satsurelOutput.nearestMandi && satsurelOutput.nearestMandi.distance) {
              this.loanRenewalForm.patchValue({
                mandi_distance: satsurelOutput.nearestMandi.distance,
              });
            }

            if (
              satsurelOutput &&
              satsurelOutput.farmStats &&
              satsurelOutput.farmStats.cropPerformance &&
              satsurelOutput.farmStats.cropPerformance.data &&
              satsurelOutput.farmStats.cropPerformance.data.length
            ) {
              this.loanRenewalForm.patchValue({
                crop_int_lastthree_years:
                  satsurelOutput.farmStats.cropPerformance.data.filter(
                    (value) => value.crop !== "-"
                  ).length,
              });
            }
          }

          //user_docs
          if (resp && resp.result && resp.result.user_docs) {
            let user_docs = resp.result.user_docs;

            if (
              user_docs &&
              user_docs.existing_loan_details &&
              user_docs.existing_loan_details.existing_limit
            ) {
              this.loanRenewalForm.patchValue({
                sanction_limit: user_docs.existing_loan_details.existing_limit,
              });
            }

            if (
              user_docs &&
              user_docs.existing_loan_details &&
              user_docs.existing_loan_details.roi
            ) {
              this.loanRenewalForm.patchValue({
                roi: user_docs.existing_loan_details.roi,
              });
            }
            if (
              user_docs &&
              user_docs.existing_loan_details &&
              user_docs.existing_loan_details.margin
            ) {
              this.loanRenewalForm.patchValue({
                margin: user_docs.existing_loan_details.margin,
              });
            }
            if (
              user_docs &&
              user_docs.existing_loan_details &&
              user_docs.existing_loan_details.type_of_facility
            ) {
              this.loanRenewalForm.patchValue({
                type_of_facilities: user_docs.existing_loan_details.type_of_facility,
              });
            }
            if (
              user_docs &&
              user_docs.existing_loan_details &&
              user_docs.existing_loan_details.roi
            ) {
              this.loanRenewalForm.patchValue({
                rate_of_interest: user_docs.existing_loan_details.roi,
              });
            }
            if (
              user_docs &&
              user_docs.existing_loan_details &&
              user_docs.existing_loan_details.existing_limit
            ) {
              this.loanRenewalForm.patchValue({
                sanction_limit_j: user_docs.existing_loan_details.existing_limit,
              });
            }
            if (
              user_docs &&
              user_docs.existing_loan_details &&
              user_docs.existing_loan_details.roi
            ) {
              this.loanRenewalForm.patchValue({
                roi_apf: user_docs.existing_loan_details.roi,
              });
            }
            if (
              user_docs &&
              user_docs.existing_loan_details &&
              user_docs.existing_loan_details.existing_limit
            ) {
              this.loanRenewalForm.patchValue({
                total_five_c: user_docs.existing_loan_details.existing_limit,
              });
            }

            this.loanRenewalForm.patchValue({
              name_of_borrower: user_docs.applicant_name ? user_docs.applicant_name : "",
            });
            this.loanRenewalForm.patchValue({
              name_of_borrower2: user_docs.applicant_name ? user_docs.applicant_name : "",
            });
            this.accNoUnmasked = user_docs.kcc_acc_no_referencenumber;
            this.loanRenewalForm.patchValue({ bank_acc_no: user_docs.kcc_acc_no_referencenumber });
            this.loanRenewalForm.patchValue({ customer_id: user_docs.custId });
            this.custId = user_docs.custId
            this.loanRenewalForm.patchValue({
              last_renewal_date: user_docs.last_renewal_date,
            });
            this.loanRenewalForm.patchValue({
              date_of_sanction: user_docs.date_of_sanction,
            });
            this.loanRenewalForm.patchValue({
              category_if_applicable: user_docs.category,
            });
            this.loanRenewalForm.patchValue({
              type_of_farmer: user_docs.type_of_farmer,
            });
            this.loanRenewalForm.patchValue({
              purpose_of_adv: user_docs.purpose_of_adv,
            });
            this.loanRenewalForm.patchValue({ dob_borrower: user_docs.dob });
            this.loanRenewalForm.patchValue({
              assest_classification: user_docs.assest_classification,
            });
            this.loanRenewalForm.patchValue({
              due_date_of_review: user_docs.renewal_duedate_for_credit_limit,
            });
            this.loanRenewalForm.patchValue({
              credit_facility_since: user_docs.credit_facility_since,
            });
            this.loanRenewalForm.patchValue({ mobile_number: user_docs.mobile_no });
            this.loanRenewalForm.patchValue({
              aadhaar_number: user_docs.aadhar_details.aadharNo,
            });
            this.loanRenewalForm.patchValue({
              existing_dp_apf: user_docs.existing_dp,
            });
            this.loanRenewalForm.patchValue({
              existing_drawing_power: user_docs.existing_dp,
            });

            if (user_docs && user_docs.resAdd && user_docs.resAdd.address) {
              this.loanRenewalForm.patchValue({
                corps_address:
                  user_docs.resAdd.address +
                  ", " +
                  user_docs.resAdd.state +
                  ", " +
                  user_docs.resAdd.postal_code,
              });
            }
          }

          this.loanRenewalForm.patchValue({
            securities:
              "Hypothecation of Standing Crops and other Securities as per existing terms of sanction.",
          });

          if (
            resp &&
            resp.result &&
            resp.result.cropping_details &&
            resp.result.cropping_details.cropping_pattern &&
            resp.result.cropping_details.cropping_pattern.length
          ) {
            this.cropping_pattern_data = resp.result.cropping_details.cropping_pattern;
            this.cropping_pattern_data1 = resp.result.cropping_details.cropping_pattern;
            this.loanRenewalForm.patchValue({
              acresum: resp.result.cropping_details.cropping_pattern[0].total_area.toFixed(2),
            });



            console.log(resp.result.final_form_submitted_data.croparraydata.length)
            if (resp && resp.result && resp.result.final_form_submitted_data && resp.result.final_form_submitted_data.croparraydata && resp.result.final_form_submitted_data.croparraydata.length) {
              if (resp && resp.result && resp.result.final_form_submitted_data && resp.result.final_form_submitted_data.croparraydata) {
                let final_data = resp.result.final_form_submitted_data.croparraydata;
                if ((final_data[0] && final_data[0].add_sof_percent && final_data[0].add_sof_percent === "") || (final_data[1] && final_data[1].add_sof_percent && final_data[1].add_sof_percent === "") || (final_data[0] && final_data[0].add_sof_percent && final_data[0].add_sof_percent == null) || (final_data[1] && final_data[1].add_sof_percent && final_data[1].add_sof_percent == null)) {
                  // console.log('ending1',final_data[0].add_sof_percent);
                  this.isAddcustomClass = true;
                }
                console.log(final_data, "final dataaaaaaaaaaaaa")
                for (let i = 0; i < final_data.length; i++) {

                  if (final_data[i].crop_name) {
                    (this.cropDataForm.controls.cropArray as UntypedFormArray).push(this.fb.group({
                      crop_season: [final_data[i].crop_season ? final_data[i].crop_season : ""],
                      crop_name: [final_data[i].crop_name ? final_data[i].crop_name : ""],
                      area: [final_data[i].area ? final_data[i].area : ""],
                      scal_of_fin: [final_data[i].scal_of_fin ? final_data[i].scal_of_fin : ""],
                      loan_amount: [final_data[i].loan_amount ? final_data[i].loan_amount : ""],
                      add_sof_percent: [final_data[i].add_sof_percent ? final_data[i].add_sof_percent : null, [Validators.min(0), Validators.max(100)]],
                      add_sof_amt: [final_data[i].add_sof_amt ? final_data[i].add_sof_amt : 0]
                    }))
                  }
                  this.calcsof(i);
                }
              }
              this.calcsof(0);
            } else {
              for (let i = 0; i < this.cropping_pattern_data.length; i++) {
                if (this.cropping_pattern_data[i].crop_name) {
                  (this.cropDataForm.controls.cropArray as UntypedFormArray).push(this.fb.group({
                    crop_season: [this.cropping_pattern_data[i].crop_season ? this.cropping_pattern_data[i].crop_season : ""],
                    crop_name: [this.cropping_pattern_data[i].crop_name ? this.cropping_pattern_data[i].crop_name : ""],
                    area: [this.cropping_pattern_data[i].area ? this.cropping_pattern_data[i].area : ""],
                    scal_of_fin: [this.cropping_pattern_data[i].scal_of_fin ? this.cropping_pattern_data[i].scal_of_fin : ""],
                    loan_amount: [this.cropping_pattern_data[i].loan_amount ? this.cropping_pattern_data[i].loan_amount : ""],
                    add_sof_percent: [this.cropping_pattern_data[i].add_sof_percent ? this.cropping_pattern_data[i].add_sof_percent : 0, [Validators.min(0), Validators.max(200)]],
                    add_sof_amt: [this.cropping_pattern_data[i].add_sof_amt ? this.cropping_pattern_data[i].add_sof_amt : 0]
                  }))
                }
              }
              // this.calcsof(0);
            }

          }

          // resp_cropping_details
          if (resp && resp.result && resp.result.cropping_details) {
            let resp_cropping_details = resp.result.cropping_details;
            this.resp_cropping_details = resp.result.cropping_details;
            this.loanRenewalForm.patchValue({
              crop_insurance_amount: resp_cropping_details.crop_insurance_amount
                ? resp_cropping_details.crop_insurance_amount
                : 0,
            });
            this.loanRenewalForm.patchValue({
              total_limit: resp_cropping_details.total_loan_amount
                ? resp_cropping_details.total_loan_amount
                : "",
            });
            this.loanRenewalForm.patchValue({
              ten_per_limit_post_harvest: resp_cropping_details.other_consumption_amount
                ? resp_cropping_details.other_consumption_amount
                : "",
            });
            this.loanRenewalForm.patchValue({
              twenty_per_limit_maint_expenses: resp_cropping_details.other_maintenance_amount
                ? resp_cropping_details.other_maintenance_amount
                : "",
            });
            this.loanRenewalForm.patchValue({
              gross_assessed_limit: resp_cropping_details.grossAssesmentLimit
                ? resp_cropping_details.grossAssesmentLimit
                : "",
            });

          }

          this.loanRenewalForm.patchValue({ type_of_facility: "1" });
          // debugger
          if (resp.result && resp.result.user_docs && resp.result.user_docs.existing_loan_details) {
            // window.alert("Something")
            this.loanRenewalForm.patchValue({ outstanding_as_on: resp.result.user_docs.existing_loan_details.outstanding_as_on ? resp.result.user_docs.existing_loan_details.outstanding_as_on : 0 });
          }

          this.loanRenewalForm.patchValue({
            existing_loan_in_lakhs: "Krishna",
          });
          this.loanRenewalForm.patchValue({ dateofmaker: currentDate });

          if (
            resp &&
            resp.result &&
            resp.result.coapplicant_data &&
            resp.result.coapplicant_data.length &&
            resp.result.coapplicant_data[0] &&
            resp.result.coapplicant_data[0].creditScore
          ) {
            this.loanRenewalForm.patchValue({
              crif_score_coapp: resp.result.coapplicant_data[0].creditScore,
            });
            this.crif_score_coappflag = true;
          }
          if (
            resp &&
            resp.result &&
            resp.result.coapplicant_data &&
            resp.result.coapplicant_data.length &&
            resp.result.coapplicant_data[0] &&
            resp.result.coapplicant_data[0].coapplicant_name
          ) {
            this.loanRenewalForm.patchValue({
              name_of_coapp: resp && resp.result && resp.result.coapplicant_data && resp.result.coapplicant_data[0] && resp.result.coapplicant_data[0].coapplicant_name ? resp.result.coapplicant_data[0].coapplicant_name : "",
            });
          }

          //RESSD1
          if (resp && resp.result && resp.result.final_form_submitted_data) {
            let ressd1 = resp.result.final_form_submitted_data;

            this.loanRenewalForm.patchValue({
              land_value: ressd1.land_value ? ressd1.land_value : "",
            });
            this.landValuesArray = ressd1.land_value;
            this.loanRenewalForm.patchValue({
              nameofthemaker: ressd1.nameofthemaker
                ? ressd1.nameofthemaker
                : "",
            });
            this.loanRenewalForm.patchValue({
              empIdofmaker: ressd1.empIdofmaker ? ressd1.empIdofmaker : "",
            });
            this.loanRenewalForm.patchValue({
              dateofmaker: ressd1.dateofmaker ? ressd1.dateofmaker : "",
            });

            this.loanRenewalForm.patchValue({
              proposed_sof_ro: ressd1.proposed_sof_ro
                ? ressd1.proposed_sof_ro
                : 0,
            });
            this.loanRenewalForm.patchValue({
              final_assed_limit: ressd1.final_assed_limit
                ? ressd1.final_assed_limit
                : 0,
            });

            this.loanRenewalForm.patchValue({
              add_sof: ressd1.add_sof ? ressd1.add_sof : "",
            });
            this.loanRenewalForm.patchValue({
              proposed_dp_k: ressd1.proposed_dp_k ? ressd1.proposed_dp_k : 0,
            });
            this.loanRenewalForm.patchValue({
              sof_ofkrs: ressd1.sof_ofkrs ? ressd1.sof_ofkrs : "",
            });

          }


          if (resp && resp.result && resp.result.consent_approval_data) {
            let checkerdata = resp.result.consent_approval_data;

            console.log(this.maker_checker_submitflag, 'this.maker_checker_submitflag');
            this.loanRenewalForm.patchValue({
              nameofthechecker: checkerdata.nameofthechecker
                ? checkerdata.nameofthechecker
                : "",
            });
            this.loanRenewalForm.patchValue({
              empIdofchecker: checkerdata.empIdofchecker
                ? checkerdata.empIdofchecker
                : "",
            });
            this.loanRenewalForm.patchValue({
              dateofchecker: checkerdata.dateofchecker ? checkerdata.dateofchecker : "",
            });

            this.loanRenewalForm.patchValue({
              nameofthemaker: checkerdata.nameofthemaker
                ? checkerdata.nameofthemaker
                : "",
            });
            this.loanRenewalForm.patchValue({
              empIdofmaker: checkerdata.empIdofmaker ? checkerdata.empIdofmaker : "",
            });
            this.loanRenewalForm.patchValue({
              dateofmaker: checkerdata.dateofmaker ? checkerdata.dateofmaker : "",
            });
            //cbs_status
            let cbs_status = resp.result.cbs_auto_renewal_status
            if (cbs_status && cbs_status == "A") {
              this.loanRenewalForm.patchValue({
                cbs_status: "Approved",
              });
            } else if (cbs_status && cbs_status == "R") {
              this.loanRenewalForm.patchValue({
                cbs_status: "Rejected",
              });
            }

          }

          //RESD5 SATSURE

          if (
            resp &&
            resp.result &&
            resp.result.satSureData &&
            resp.result.satSureData.input &&
            resp.result.satSureData.input.length
          ) {
            console.warn(resp.result.satSureData.input, "Data to pass");
            // this.multisatsuredatas = resp.result.satSureData.input;

            for (let i = 0; i < resp.result.satSureData.input.length; i++) {
              if (resp.result.satSureData.input && resp.result.satSureData.input[i] && resp.result.satSureData.input[i].wlOutput && resp.result.satSureData.input[i].wlOutput.report) {
                this.multisatsuredatas.push(resp.result.satSureData.input[i]);
                this.landValueArrayLength++
              }
            }
          }


        }
      },(err)=>{
        this.snackbar.open("Failed to fetch information","OK",{duration:3000})
      });
  }

  getOverallStatus() {
    return new Promise(async (resolve, relect) => {
      this.applicant.getOverAllStatus().subscribe((resp) => {
        console.log("overallstatus", resp);
        if (resp && resp.data && resp.data.landDetails &&
          resp.data.consent_feedback_status && resp.data.consent_feedback_status == "yes" &&
          resp.data.cicReport && !resp.data.npaStatus) {
          resolve(true);
        } else if (resp && resp.data && !resp.data.landDetails) {
          this.overAllStatusMessageToDisplay = "Land verification not complete.";
          this.showOverallCard = true;
          resolve(false);
        } else if (resp && resp.data && resp.data.consent_feedback_status && resp.data.consent_feedback_status != "yes") {
          this.overAllStatusMessageToDisplay = "Consent form not submitted/ Consent is not provided."
          this.showOverallCard = true;
          resolve(false);
        } else if (resp && resp.data && (!resp.data.cicReport || resp.data.npaStatus)) {
          this.overAllStatusMessageToDisplay = "Customer failed at credit check."
          this.showOverallCard = true;
          resolve(false);
        }
      },(err)=>{
        this.snackbar.open("Failed to fetch status information","OK",{duration:3000});
        resolve(false);
      })
    })
  }

}







